import * as React from 'react';
import ReactDOM from 'react-dom';
import { Dialog,DialogFooter  } from 'office-ui-fabric-react/lib/Dialog';
import { PrimaryButton, DefaultButton} from 'office-ui-fabric-react/lib/Button';

import { Fabric } from 'office-ui-fabric-react/lib/Fabric';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { TextField } from 'office-ui-fabric-react/lib/TextField';

import { Loading } from './Loading.js';
import { RecuperaPassword } from './RecuperaPassword.js';

import { Config } from './Config.js';
import { Session } from './classi/Session.js';
import { Utils } from './classi/Utils.js';

import { AreaClientePanel } from './AreaClientePanel.js';
import { PrimoAccesso } from './PrimoAccesso.js';

const sessione = new Session();
const config = new Config();
const utils = new Utils();

export class LoginWindow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hidden: false,
            username: '',
            password: '',
            usernameError : '',
            passwordError: '',
            
            mostraBottoneRecupera : '',
            
            buttonDisabled : false,

            showLOGIN_PRIVACY : 'nascosto',
            textLOGIN_PRIVACY : '',
            
            showMESSAGGIO_LOGIN : 'nascosto',
            textMESSAGGIO_LOGIN : '',

            textREGISTRATI : "Primo Accesso",
            
            version : config.getVersion(),
            classeHeader : 'loginpage',
            
            chkBoxFlaggato:false,
            
            classLogo : 'logo',
            vediImage1 : 'nascosto',
            vediImage2 : 'nascosto',
            
            linkImage1 : '',
            linkImage2 : '',
            linkLogo : '',
            
            labelUsername : 'Username'
        };

        this.execLogin = this.execLogin.bind(this);
        this._onCheckboxChange = this._onCheckboxChange.bind(this);
        this.execLogin = this.execLogin.bind(this);
        this.caricaAreaClientiPanel = this.caricaAreaClientiPanel.bind(this);
        
        this.eseguiAutoLogin = this.eseguiAutoLogin.bind(this);
        this._controllaAutologin = this._controllaAutologin.bind(this);
        
        this.controllaParametri = utils.controllaParametri.bind(this);
        this.controllaParametri(0);
        
        // se l'utente è già loggato riparto dalla pagina dell'area clienti
        if( sessione.get('id_cliente') !== null ){ this.caricaAreaClientiPanel(); }
        
        // 2019-01-29 ... qui gestisco l'autologin se arrivo da area clienti
        this._controllaAutologin(0);
        
        this.centralogo = this.centralogo.bind(this);
    }
    
    componentDidMount() {  
        
        this.centralogo(0);
        
        this.etichettaUsername(0);
        
        this.mostraImage(0);
        this.controllaLink(0);
        
        // 2019-01-30
        setTimeout(function(){
            let autologin = utils.getObjInfoSocieta( 'autologin' , false );
            
            if( autologin !== true ) { 
                let titolo = utils.getObjInfoSocieta( 'MS_TITOLO_LOGIN_AREA_CLIENTI' , 'Login Area Clienti' );
                document.title = titolo+" "+config.getVersion();
            }else{
                let titolo = utils.getObjInfoSocieta( 'MS_TITOLO_AREA_CLIENTI' , 'Area Clienti' );
                document.title = titolo+" "+config.getVersion();
            }
        },250);
    }
    
    etichettaUsername(conta){
        let eti = utils.getObjInfoSocieta( 'LABEL_USERNAME' , false );
        if( eti !== false && eti !== '' && eti !== 'null' && eti !== null && conta < 50 ) {  
            this.setState({ labelUsername : eti});
        }
        else { setTimeout( function(){  this.etichettaUsername( conta+1 );  }.bind(this) , 50 ); }
    }
    
    centralogo(conta){
        let posLogo = utils.getObjInfoSocieta( 'POSIZIONELOGOAC2' , false );
        if( posLogo !== false && conta < 50 ) {  
            if(posLogo === 'centro'){ this.setState({classeHeader: 'loginpage pagecentrato'}); } 
            let logolargo = utils.getObjInfoSocieta( 'LOGOLARGO' , false );
            if( logolargo !== false && logolargo==='SI'){ this.setState({classLogo: 'logo logolargo'}); }
        }
        else { setTimeout( function(){  this.centralogo( conta+1 );  }.bind(this) , 50 ); }
    }

    mostraImage(conta){
        let colori = utils.getObjInfoSocieta( 'colori' , false );
        
        if(colori !== false && conta < 50)
        {
            if('--addImage1' in colori){
                if( colori['--addImage1'] !== "url('')") { this.setState({ vediImage1 : 'image1' }); }
            }
            if('--addImage2' in colori){
                if( colori['--addImage2'] !== "url('')") { this.setState({ vediImage2 : 'image2' });}
            }
        }
        else {
            setTimeout( function(){  this.mostraImage(conta+1);  }.bind(this) , 25 );
        }
    }
    
    controllaLink(conta){
        let link1 = utils.getObjInfoSocieta( 'ADDIMAGE1LINK' , false );
        let link2 = utils.getObjInfoSocieta( 'ADDIMAGE2LINK' , false );
        let linkLogo = utils.getObjInfoSocieta( 'LOGOLINK' , false ); 
        
        if( (link1 !== false || link2 !== false || linkLogo !== false) && conta < 50){
            this.setState({ linkImage1 : link1, linkImage2 : link2 , linkLogo:linkLogo });
        } else {
            setTimeout( function(){  this.controllaLink(conta+1);  }.bind(this) , 25 );
        }
    }

  
    recuperapassword()
    {
        ReactDOM.render(<RecuperaPassword />, document.getElementById('root'));
    }

    
    _controllaAutologin( conta )
    {
        if( conta < config.getTentativiAutologin() )
        {
            let autologin = utils.getObjInfoSocieta( 'autologin' , false );
            if( autologin === true ) { this.eseguiAutoLogin(); }  
            else { setTimeout( function(){  this._controllaAutologin( conta+1 );  }.bind(this) , 50 ); }
        }
    }

    _onCheckboxChange(ev , flaggato){
        
        this.setState({ chkBoxFlaggato:flaggato });
        
        if(this.state.username !== '' && this.state.password !== ''){
            this.setState({ buttonDisabled:!flaggato });
        }
    }
  
    usernameChanged = (newValue) => {
        this.setState({username: newValue});
        
        if( this.state.password === '' || newValue==='' || ( this.state.chkBoxFlaggato===false && this.state.showLOGIN_PRIVACY==='' ) ){
            console.log("USER 1");
            this.setState({ buttonDisabled:true , chkBoxFlaggato:false });
        } else if( this.state.password !== '' && newValue !=='' && this.state.showLOGIN_PRIVACY==='nascosto' ){
            console.log("USER 2");
            this.setState({ buttonDisabled:false , chkBoxFlaggato:false });
        } else {
            console.log("USER 3");
        }
    }

    passwordChanged = (newValue) => {
        this.setState({password: newValue});
        
        if(this.state.username === '' || newValue==='' || ( this.state.chkBoxFlaggato===false && this.state.showLOGIN_PRIVACY==='' ) ){
            console.log("PASS 1");
            this.setState({ buttonDisabled:true , chkBoxFlaggato:false });
        } else if( this.state.username !== '' && newValue !=='' && this.state.showLOGIN_PRIVACY==='nascosto' ){
            console.log("PASS 2");
            this.setState({ buttonDisabled:false , chkBoxFlaggato:false });
        } else {
            console.log("PASS 3");
        }
    }

    execLogin() {
        this.setState({usernameError: '', passwordError: ''});

        let user = this.state.username;
        let pass = this.state.password;


        if( user !== '' && pass !== '')
        {
            let request = new Request( config.getCustomersLogin(),{
                method: 'POST',mode: 'cors', credentials: "include",
                body: JSON.stringify({username: user, password: pass})
            });

            fetch(request)
            .then(function(response){
                return response.json();
            })
            .then(function(result){
                if (result.success){
                    // acquisisco in SESSIONE l'ID del cliente

                    if( result.data.id_aggregato > 0){
                        sessione.set('id_aggregato' ,result.data.id_aggregato );
                        sessione.set('id_cliente' , -9999 );
                    }
                    else if( result.data.id_amministratore > 0){
                        sessione.set('id_amministratore' ,result.data.id_amministratore );
                        sessione.set('id_cliente' , -9999 );
                    }
                    else{
                        sessione.set('id_cliente' ,result.data.id_cliente );
                    }



                    // carico il loading
                    var x = document.getElementsByClassName("ms-Dialog-main");
                    ReactDOM.render(<Loading />, x[0] );

                    // LEGGO le configurazioni Personali x l'utente
                    utils.leggiImpostazioniPersonali();

                    // qui provo il caricamento del pannello
                    this.caricaAreaClientiPanel();
                } else {
                    this.setState({usernameError: result.message, passwordError: ' '});
                }
            }.bind(this) ).catch(function() {
                this.setState({usernameError: 'Errore invio dati', passwordError: ' '});
            }.bind(this) );
        }
        else
        {
            this.setState({usernameError: 'è necessario inserire una username', passwordError: 'è necessario inserire una password'});
        }
    };
    
    
    eseguiAutoLogin() {
        this.setState({usernameError: '', passwordError: ''});

        let request = new Request( config.get('customers_autologin'),{
            method: 'POST',mode: 'cors', credentials: "include",
            body: JSON.stringify({autologin:1})
        });

        fetch(request)
        .then(function(response){
            return response.json();
        })
        .then(function(result){
            if (result.success){

                // acquisisco in SESSIONE l'ID del cliente
                sessione.set('id_cliente' ,result.data.id_cliente );

                // carico il loading
                var x = document.getElementsByClassName("ms-Dialog-main");
                ReactDOM.render(<Loading />, x[0] );

                // LEGGO le configurazioni Personali x l'utente
                utils.leggiImpostazioniPersonali();

                // qui provo il caricamento el pannello
                this.caricaAreaClientiPanel();
               
            } else {
                this.setState({usernameError: result.message, passwordError: ' '});
            }
        }.bind(this) ).catch(function() {
            this.setState({usernameError: 'Errore invio dati', passwordError: ' '});
        }.bind(this) );

    };

    caricaAreaClientiPanel(){
        let datainfo = sessione.get('datainfo');
        
        if( utils.isObjectFull( datainfo ) === true ){ 
            // 2019-01-30
            let titolo = utils.getObjInfoSocieta( 'MS_TITOLO_AREA_CLIENTI' , 'Area Clienti' );
            document.title = titolo+" "+config.getVersion();

            ReactDOM.render(<AreaClientePanel />, document.getElementById('root')); 
        } else { setTimeout( function(){ this.caricaAreaClientiPanel(); }.bind(this) , 25 ); }
    }

    registrati = (event) => {
        ReactDOM.render(<Fabric><PrimoAccesso /></Fabric> , document.getElementById('root'));
    }
  
    keyPressed = (event) => {
        if (event.key === 'Enter' && this.state.buttonDisabled === false) { this.execLogin();}
    }

    render() {
        return (
            <div id="main-container" className="loginpage">
            <header className={this.state.classeHeader}>
            <a href={this.state.linkLogo} target="_blank" className="linkimage"><span className={this.state.classLogo}>&nbsp;</span></a>&nbsp;
                <a href={this.state.linkImage1} target="_blank" className="linkimage"><span className={this.state.vediImage1}>&nbsp;</span></a>&nbsp;
                <a href={this.state.linkImage2} target="_blank" className="linkimage"><span className={this.state.vediImage2}>&nbsp;</span></a>&nbsp;                
            </header>
            <Dialog dialogContentProps={{ title : "Login Area Cliente" }} hidden={this.state.hidden}  modalProps={{ isBlocking: false, containerClassName: 'ms-dialogMainOverride' }}>
                
                <div className={this.state.showMESSAGGIO_LOGIN}>
                    <div dangerouslySetInnerHTML={{__html: this.state.textMESSAGGIO_LOGIN}}></div>
                </div>
                
                <div>
                    <TextField label={this.state.labelUsername} required={true} errorMessage={this.state.usernameError} value={this.state.username} onChanged={this.usernameChanged} iconProps={{iconName: 'Contact'}} onKeyPress={this.keyPressed}/>
                    <TextField label="Password" required={true} errorMessage={this.state.passwordError} type="password" value={this.state.password} iconProps={{iconName: 'Lock'}} onChanged={this.passwordChanged} onKeyPress={this.keyPressed} />
                </div>

                <div className={this.state.showLOGIN_PRIVACY}>
                    <div className="msGrid"><div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm2">
                            <Checkbox onChange={this._onCheckboxChange} checked={this.state.chkBoxFlaggato}/>
                        </div>
                        <div className="ms-Grid-col ms-sm10" dangerouslySetInnerHTML={{__html: this.state.textLOGIN_PRIVACY}}></div>
                    </div></div>
                </div>

                <DialogFooter>
                    <PrimaryButton text="Esegui Login" primary={true} onClick={this.execLogin} disabled={this.state.buttonDisabled}/>
                    <DefaultButton text={this.state.textREGISTRATI} onClick={this.registrati} />
                    <DefaultButton text="Recupera Password" onClick={this.recuperapassword} className={this.state.mostraBottoneRecupera}/>
                </DialogFooter>
            </Dialog>
            <footer className="loginpage"><i className="ms-Icon ms-Icon--Info" aria-hidden="true"></i> Versione {this.state.version}</footer>
            </div>
        );
    }
}

export default LoginWindow;


// WEBPACK FOOTER //
// ./src/AcComponents/LoginWindow.js